import React from 'react';

import ComparisonTable from 'common/Table/ComparisonTable';
import { getDifferenceColor } from 'common/Widgets/valueDifferenceUtils';
import {
  MyCommunitiesMarketRateComparison,
  MyCommunitiesMarketRateRow,
  MyCommunitiesRateGap,
} from 'types/recommendations';

import { getCompetitorComparisonLabel, MIN_COMPETITORS_FOR_AVERAGE } from './constants';

type Props = {
  careTypes: MyCommunitiesMarketRateComparison[];
  defaultActiveCareTypeId?: number;
  rateGap?: MyCommunitiesRateGap | null;
};

const MyCommunitiesRateComparisonTable = ({ careTypes, defaultActiveCareTypeId, rateGap }: Props) => (
  <ComparisonTable<MyCommunitiesMarketRateRow, MyCommunitiesMarketRateComparison>
    careTypes={careTypes}
    defaultActiveCareTypeId={defaultActiveCareTypeId}
    getValueColumns={(careType) =>
      careType.room_types.map((roomType) => ({
        key: `room-type-${roomType}`,
        title: `${roomType} MIN`,
        getValue: (row) => row.rates[roomType] ?? null,
        getOwnDifferenceLabel: () => {
          const comparison = careType.competitor_averages[roomType];
          if (!comparison) return null;

          const percent = Math.round(comparison.diff_percent);
          return {
            color: getDifferenceColor(-percent),
            text: `${percent > 0 ? '+' : ''}${percent}% ${getCompetitorComparisonLabel(comparison.competitor_count)}`,
          };
        },
        isHighlighted: rateGap?.care_type_id === careType.care_type_id && rateGap?.room_type === roomType,
      }))
    }
    getSummaryRow={(careType) => {
      const getAverageRate = (roomType: string) => {
        const comparison = careType.competitor_averages[roomType];
        return comparison && comparison.competitor_count >= MIN_COMPETITORS_FOR_AVERAGE ? comparison.rate : null;
      };
      if (careType.room_types.every((roomType) => getAverageRate(roomType) === null)) return null;

      return {
        community_id: -1,
        community_name: 'Competitor Average',
        is_own: false,
        rates: Object.fromEntries(careType.room_types.map((roomType) => [roomType, getAverageRate(roomType)])),
      };
    }}
  />
);

export default MyCommunitiesRateComparisonTable;
